import { render, staticRenderFns } from "./adminuser_mr.vue?vue&type=template&id=2a1a13e8&scoped=true"
import script from "./adminuser_mr.vue?vue&type=script&lang=js"
export * from "./adminuser_mr.vue?vue&type=script&lang=js"
import style0 from "./adminuser_mr.vue?vue&type=style&index=0&id=2a1a13e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a13e8",
  null
  
)

export default component.exports